import type { BaseEditor } from 'slate';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import type { EmptyElement } from '../../types';

export interface MentionEditor extends BaseEditor {
  insertMention: (user: ChatGroupMember) => void;
}

export const MentionElementType = 'mention';

export interface MentionElement extends EmptyElement {
  type: typeof MentionElementType;
  user: ChatGroupMember;
}
